import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Button2 from "../button/Button2";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "../../API/axios";
import CompanyImg from '../../assets/images/khoj-images/image 484.png'
import moment from "moment/moment";

Job05.propTypes = {};

function Job05() {
  // const { data } = props;
  const token = localStorage.getItem('token')

  // ...............................All Job List.......................................

  const [jobList, setjobList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getAlljobList = (page) => {
    const data = {
      pageNumber: page,
      pageSize: 10,
    };

    axios
      .post(`/Job/GetAll`, data)
      .then((response) => {

        const res = response.data.responseData.jobsList;
        // console.log("getAlljobList", response.data.responseData.jobsList);
        setjobList(res);
        setIsLoading(false);

      })
      .catch((error) => {
        console.log("error", error)
      });
  };

  useEffect(() => {
    getAlljobList(); // Initial fetch on mount
  }, []);

  // ...............................All Jobs List.......................................

  return (
    <section className="jobs-section container nonloginFeature pt-3">
      <Tabs className="wrap-testimonials style-1 over-flow-hidden tf-tab">
        <div className="container">
          <div className="tf-title style-3 margin">
            <div className="group-title">
              <h1>Featured Jobs</h1>
              <p>Find the right career opportunity for you</p>
            </div>
           
          </div>
          <div className="content-tab">
            <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
            <div className="group-col-4 Featured-Job-Section">
              
              {jobList.slice(0, 6).map((data) => (
                <div key={data.id} className="col-lg-4 col-md-6 Featured-Jobs-Cards">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={CompanyImg} alt="jobtex" />
                          {/* <img src={data.img} alt="jobtex" /> */}
                        </div>
                        <div className="box-content">
                          <h4>
                            {token === null ? data.compName : <Link to={`/jobDetails/${data.jobId}`} >{data.compName}</Link>}
                          </h4>
                          <h3>
                            {token === null ? data.title : <Link to={`/jobDetails/${data.jobId}`}> {data.title} </Link>}

                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {data.cityName}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {/* {data.creationTime} */}
                              {moment
                                .utc(data.creationTime)
                                .local()
                                .format("DD MMMM YYYY")}
                            </li>
                          </ul>
                          {/* <span className="icon-heart"></span> */}
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left ">
                        <ul className="job-tag Job-Footer-Small-Button">
                          <li>
                            <Link to="#/">{data.jbTypName}</Link>
                          </li>
                          <li>
                            <Link to="#/">{data.workLevelTypename}</Link>
                          </li>
                          <li>
                            <Link to="#/">{data.workLocationTypeName}</Link>
                          </li>
                          <li>
                            <Link to="#/">{data.designationName}</Link>
                          </li>
                        </ul>
                        {/* <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div> */}
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          {/* <span className="icon-dolar1"></span> */}
                          <p className="mb-0">
                            {data.currency} {data.minSalary} / {data.salaryTypeName}
                            <span className="year"></span>
                          </p>
                        </div>
                        <p className="days mb-0">{data.apply}</p>
                      </div>
                    </div>
                    {/* <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link> */}
                  </div>
                </div>
              ))}
            </div>
              <div className="col-md-12">
                <div className="wrap-button d-flex justify-content-center">
                  {/* <Button2 title="See more Jobs" link="/joblist_v1" /> */}
                  <div className="khojPrimaryBtn1 ms-3" style={{ width: '150px' }}>
                    <Link to="/SearchJobs" className="">See More Jobs</Link>
                  </div>
                </div>
              </div>
            </TabPanel>
            {/* <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="jobtex" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel>
            <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="jobtex" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel>
            <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="jobtex" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel>
            <TabPanel className="row wow fadeInUp animation-tab job-tab-item">
              {data.slice(0, 6).map((idx) => (
                <div key={idx.id} className="col-lg-6 ">
                  <div className="features-job">
                    <div className="job-archive-header">
                      <div className="inner-box">
                        <div className="logo-company">
                          <img src={idx.img} alt="jobtex" />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to="/jobDetails">{idx.cate}</Link>
                          </h4>
                          <h3>
                            <Link to="/jobDetails"> {idx.title} </Link>
                            <span className="icon-bolt"></span>
                          </h3>
                          <ul>
                            <li>
                              <span className="icon-map-pin"></span>
                              &nbsp;
                              {idx.map}
                            </li>
                            <li>
                              <span className="icon-calendar"></span>
                              &nbsp;
                              {idx.time}
                            </li>
                          </ul>
                          <span className="icon-heart"></span>
                        </div>
                      </div>
                    </div>
                    <div className="job-archive-footer">
                      <div className="job-footer-left">
                        <ul className="job-tag">
                          <li>
                            <Link to="#">{idx.jobs1}</Link>
                          </li>
                          <li>
                            <Link to="#">{idx.jobs2}</Link>
                          </li>
                        </ul>
                        <div className="star">
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                          <span className="icon-star-full"></span>
                        </div>
                      </div>
                      <div className="job-footer-right">
                        <div className="price">
                          <span className="icon-dolar1"></span>
                          <p>
                            {idx.price}
                            <span className="year">/year</span>
                          </p>
                        </div>
                        <p className="days">{idx.apply}</p>
                      </div>
                    </div>
                    <Link
                      to="/jobDetails"
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                </div>
              ))}
              <div className="col-md-12">
                <div className="wrap-button">
                  <Button2 title="See more Jobs" link="/joblist_v1" />
                </div>
              </div>
            </TabPanel> */}
          </div>
        </div>
      </Tabs>
    </section>
  );
}

export default Job05;
